import {
AppLayout,
AppLayoutProps,
Box,
ColumnLayout,
ColumnLayoutProps,
Container,
ContentLayout,
Grid,
Header,
Link,
SpaceBetween,
TextContent,
Badge,
Button,
Tabs,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { link } from "fs";
import Series_Drivers from "../drivers";
import Series_Teams from "../teams";
import Series_Results from "../results";
import Series_Calendar from "../calendar";
import Series_Rules from "../trinations/rules";
import Series_Stats from "../stats";
import Series_Livery from "../livery";
import * as awsui from "@cloudscape-design/design-tokens";
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import SeriesNav from "../../../components/series-navbar/series-nav";
import GetSeriesContent from "../get-series-content";
import Rules from "./rules";
import Gallery from "./gallery";
import Register from './register';
import Results from "./results";
import Calendar from "./calendar";
import DriversAndTeams from "./teams";
import Stats from "./stats";



export default function Series() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme, 
    density, setDensity,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);
  
  const screenWidth_600 = useMediaQuery({query: "only screen and (max-width : 600px)"})
  const screenWidth_800 = useMediaQuery({query: "only screen and (max-width : 800px)"})
  const screenWidth_1000 = useMediaQuery({query: "only screen and (max-width : 1000px)"})


  return (
    <>
      <center>
        <div style={{
          background: "none", 
          width: "100%", 
          paddingTop: "50px", 
          paddingBottom: screenWidth_600? "20px" : "50px"
        }}>
          <div className="body-content">
            <Box>
              <div style={{
                maxWidth: screenWidth_600? "100%": "80%"
              }}>
                <img 
                  src={theme === Mode.Light ? "/images/apjc/apjc-challenge-logo-dark.png" : "/images/apjc/apjc-challenge-logo-light.png"}
                  style={{
                    width: "100%"
                  }}
                />            
                <div style={{
                  textAlign: "left", 
                  fontSize: screenWidth_600? "1.4rem": "2rem", 
                  lineHeight: "40px", 
                  marginTop: "30px", 
                  color: awsui.colorTextBodySecondary
                }}>
                  {/* <h4>19TH & 20TH AUGUST 2023</h4> */}
                  19TH & 20TH AUGUST 2023
                </div>
              </div>
            </Box>
          </div>
        </div>
        <div style={{background: awsui.colorBackgroundItemSelected, width: "100%", paddingTop: "20px", paddingBottom: "20px"}}>
          <div className="body-content">
            <div style={{paddingTop: "10px", paddingBottom: "40px"}}>
              <ColumnLayout columns={4} minColumnWidth={250}>
                <div style={{textAlign: "center"}}>
                  <b>Platform:</b> iRacing
                </div>
                <div style={{textAlign: "center"}}>
                  <b>Vehicle:</b> FIA F4
                </div>
                <div style={{textAlign: "center"}}>
                  <b>Circuit:</b> Imola Grand Prix Circuit
                </div>
                <div style={{textAlign: "center"}}>
                <b>Broadcast:</b> Live on&nbsp;
                  <Link 
                    href="https://youtu.be/ZozTIglo_p4?t=94"
                    target="_blank"
                  >
                    Racestars TV
                  </Link>
                </div>
              </ColumnLayout>
            </div>
            <div style={{maxWidth: "80%", justifyContent: "center", textAlign: "left"}}>
              <div style={{width: "100%", paddingTop: "20px"}}>
                <h5>Prize:</h5>
              </div>
              <div>
                The winner of the event, will attend an Elite Driver Academy* in Sepang, Malaysia in September
                2023 as an esport participant. Prize includes Flights, accommodation, and Elite Driver Academy*
                training and is all together valued at approximately $15K AUD.
              </div>
              <div style={{width: "100%", paddingTop: "20px"}}>
              <h5>Entries:</h5>
              </div>
              <div>
                Entries are open to all aspiring drivers who are aged between 14 - 17 years and are from the Asia
                Pacific and Oceania countries listed here: Australia, Bangladesh, Bhutan, Brunei, Burma, Cambodia,
                China, Hong Kong, India, Indonesia, Japan, Laos, Malaysia, Nepal, New Zealand, Pakistan, Philippines,
                Singapore, South Korea, Sri Lanka, Taiwan, Thailand, Vietnam.
              </div>
              <div style={{width: "100%", paddingTop: "20px"}}>
              <h5>Details:</h5>
              </div>
              <div>
                The winning entrant will participate in learning activities at an Elite Driver Academy*in Sepang, Malaysia,
                however as an esports participant they will not have the opportunity to drive an actual F4 vehicle.
                Participation in the Academy*, flights and accommodation are included for the winning participant,
                however as a junior they must be accompanied by an adult guardian at their own cost. All other
                associated costs ie: Meals, internal travel to and from hotel, passport etc. are not included.
              </div>
            </div>
            <div style={{paddingTop: "20px", fontSize: "12px", textAlign: "right", marginRight: "30px"}}>
            * additional details on the academy visit can be found at &nbsp;
            <Link
              href="https://motorsport.org.au/events/ferrari-driver-academy"
              target="_blank"
              fontSize="inherit"
            >
              https://motorsport.org.au/events/ferrari-driver-academy
            </Link>
          </div>
          <div style={{paddingTop: "40px"}}>
              For further information contact:&nbsp;
              <Link 
                href="mailto: esports@motorsport.org.au"
                target="_blank"
                fontSize="inherit"
              >
                Motorsport Australia E-Sports
              </Link>
            </div>
          </div>
        </div>
        <div style={{background: awsui.colorBackgroundItemSelected, width: "100%", paddingTop: "50px", paddingBottom: "20px"}}>
          <div className="body-content">
            <div style={{
              maxWidth: screenWidth_1000 ? "100%" : "80%", 
              background: 
              awsui.colorBackgroundButtonPrimaryActive, 
              borderRadius: "20px"
            }}>
              <Grid
                gridDefinition={[
                  { colspan: { default: 8, xs: 4, m: 4 } },
                  { colspan: { default: 8, xs: 4, m: 4 } },
                  { colspan: { default: 8, xs: 4, m: 4 } },
                ]}
              >  
                <div style={{display: "flex", justifyContent: "center"}}>
                  <div style={{color: awsui.colorTextButtonPrimaryActive, padding: "20px", width: "100%", maxWidth: "300px"}}>
                    <h5>Friday 18th August</h5> <p />
                    <b>18:00 AEST</b> (Session open) <br />
                    <b>PRACTICE</b> (6 hours) <br />
                    <p />
                    Non compulsory. <br />
                    <br />
                    Will be used to check
                    accessability & connection
                    speeds of entrants.
                    <p />
                    <br />
                    <b>AEST TIME <br />
                    UTC/GMT +10</b>
                  </div>
                </div>
                <div style={{display: "flex", justifyContent: "center"}}>
                  <div style={{color: awsui.colorTextButtonPrimaryActive, padding: "20px", width: "100%", maxWidth: "300px"}}>
                    <h5>Saturday 19 August</h5> <p />
                    <b>12:00 AEST</b> <br />
                    <b>PRACTICE</b> (1 hour) <br />
                    <br />
                    <b>13:00 AEST</b> <br />
                    <b>LONE QUALIFYING</b> (50 laps) <br />
                    <br />
                    This is a 6 hour session limited
                    to a maximum of 50 timed laps.
                    Fastest 50 Qualifiers proceed
                    to Sundays Racing
                  </div>
                </div>
                <div style={{display: "flex", justifyContent: "center"}}>
                  <div style={{color: awsui.colorTextButtonPrimaryActive, padding: "20px", width: "100%", maxWidth: "300px"}}>
                    <h5>Sunday 20 August</h5> <p />
                    <b>12:00 AEST</b> <br />
                    <b>PRACTICE</b> (3 Hour) <br />
                    <br />
                    <b>15:00 AEST</b> <br />
                    <b>SEMI-FINAL 1</b> (25 Cars Grid) <br />
                    <b>SEMI-FINAL 2</b> (25 Cars Grid) <br />
                    <br />
                    <b>17:00 AEST</b> <br />
                    <b>FINAL</b> (30 cars) <br />
                  </div>
                </div>
              </Grid>
            </div>
          </div>
        </div>
        <div style={{width: "100%", background: awsui.colorBackgroundItemSelected, padding: "50px"}}>
          <div className="body-content">
            <Box textAlign="center">
              <SpaceBetween size="m">
                <Link 
                  href="/signin"
                  onFollow={ (event) => {
                    event.preventDefault();
                    navigate(event.detail.href!)
                  }}
                >
                  <button
                    type="button"
                    style={{
                      height: "80px", 
                      width: "50%", 
                      minWidth: "200px",
                      background: awsui.colorBackgroundNotificationRed, 
                      borderRadius: "2px", 
                      alignItems: "center", 
                      color: "white", 
                      fontWeight: "normal", 
                      fontSize: "32px", 
                      borderWidth: "0",
                      lineHeight: "35px",
                    }}>
                    REGISTER NOW
                  </button>
                </Link>
              </SpaceBetween>
            </Box>
          </div>
        </div>
        <div style={{width: "100%", background: awsui.colorBackgroundContainerContent, paddingLeft: "20px", paddingRight: "20px", paddingTop: "20px", paddingBottom: "20px" }}>
          <ColumnLayout columns={4}>
            <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto"}}>
              <h5>MEMBER OF</h5>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/fia-logo-dark.png" : "/images/sponsor-logos/fia-logo-light.png"}
                alt="Asia-Pacific Junior Esports Challenge"
                width="60%"
              />
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto"}}>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/ma-logo-dark.png" : "/images/sponsor-logos/ma-logo-light.png"}
                alt="Asia-Pacific Junior Esports Challenge"
                width="100%"
              />
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto"}}>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/iracing-logo-dark.png" : "/images/sponsor-logos/iracing-logo-light.png"}
                alt="Asia-Pacific Junior Esports Challenge"
                width="100%"
              />
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", maxWidth: "280px", height: "100%", margin: "auto"}}>
              <img
                src={theme === Mode.Light ? "/images/sponsor-logos/frg-vert-logo-dark.png" : "/images/sponsor-logos/frg-vert-logo-light.png"}
                alt="Asia-Pacific Junior Esports Challenge"
                width="100%"
                />
            </div>
          </ColumnLayout>
        </div>
        <div style={{width: "100%", background: awsui.colorBackgroundContainerContent, paddingLeft: "20px", paddingRight: "20px", paddingTop: "20px", paddingBottom: "20px" }}>
        </div>
      </center>
    </>
  )
}
